<script setup>
import { useVModel } from '@vueuse/core'
import { cn } from '@/lib/utils'

const props = defineProps({
  defaultValue: { type: [String, Number], default: '' },
  modelValue: { type: [String, Number], default: '' },
  class: { type: String, default: '' },
})

const emits = defineEmits(['update:modelValue'])

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
})
</script>

<template>
  <textarea
    v-model="modelValue"
    :class="cn('flex min-h-[96px] w-full rounded-md border border-input bg-surface text-ink px-3.5 py-2.5 text-[15px] transition-[border-color,box-shadow] duration-150 placeholder:text-subtle focus-visible:outline-none focus-visible:border-brand focus-visible:ring-3 focus-visible:ring-brand/20 aria-invalid:border-danger disabled:cursor-not-allowed disabled:bg-surface-2 disabled:text-subtle', props.class)"
  />
</template>
